import { ActionTree } from 'vuex';
import { AuthInterface } from './state';
import { StateInterface } from '@/interfaces/projects';
import filesManagerApi from '@/api/filesManagerApi';
import store from '@/store';


const actions: ActionTree<AuthInterface, StateInterface> = {
    async loginUser(context, user ) {

        const { login, password } = user
        const data = new FormData();
        
        try {
            data.append('login', login);
            data.append('password', password);
            data.append('remember', 'true');
            
            const resp = await filesManagerApi.post('Login.action?action=login', data)

            const userSession: AuthInterface = resp.data.item;
            // Guardar los valores en el estado usando commit
            
            if(resp.data.success){
                localStorage.setItem("session", resp.data.properties.token)
                context.commit('setUserSession', userSession);
            }
            
            return resp.data
    
        } catch (error) {
            return error
        }
    
    },

    async setUserSession( {commit}, user ) {

        const { login, password } = user
        const data = new FormData();
        try {
            data.append('login', login);
            data.append('password', password);
            const resp = await filesManagerApi.post('Login.action?action=getUserSession', data);

            const userSession: AuthInterface = resp.data.item;
            // Guardar los valores en el estado usando commit
            commit('setUserSession', userSession);

        } catch (error) {
            console.error('Error al obtener el usuario de la sesión', error);
        }
    },

    // Obtiene la sesion utilizando el token jwt
    async setUserSessionJWT( {commit}, jwt) {
        const data = new FormData()
        try{
            data.append('login', jwt);
            const resp = await filesManagerApi.post('Login.action?action=getUserSession', data)

            const userSession: AuthInterface = resp.data.item

            // Si no hay datos, se maneja el error y se borra el token
            if (userSession === null) {
                localStorage.removeItem("session")
                localStorage.removeItem("refresh")
                throw new Error("No se han recibido datos de la sesion del usuario")
            }
            
            commit('setUserSession', userSession) // Guarda los datos de la sesion
        } catch (error) {
            console.error('Error al obtener el usuario de la sesión con JWT', error)
        }

    },

    logoutUser( { commit }, router ) {
        // Limpiamos el timer porque logout va a recargar la pagina
        this.dispatch('auth/clearKeepalive', router);
        // Elimina la sesión y redirige al login

        filesManagerApi.post('Login.action?action=logout');

        router.push("/")
        
    },
    
    async startKeepalive(state, router){
        const keepaliveInterval = setInterval(async function(){
            const now = new Date()
            const response = await filesManagerApi.get('/KeepAlive.action');

            
            if( !response?.data?.success){
                state.dispatch('clearKeepalive', router)
            }
        // Cada 20 minutos se manda peticion, a los 30 mins caduca la sesion en back
        }, 20 * 60 * 1000);
        
        state.commit('setKeepaliveInterval', keepaliveInterval); 
    },
    
    async clearKeepalive({getters, commit}, router){
        // Vaciamos la sesión de usuario
        const blankSession : AuthInterface = {nombre:"", tipo:0, id_usuario:0};
        commit( 'setUserSession', blankSession);

        // Liberamos el intervalo
        const keepAliveId = getters['getKeepaliveInterval']; 
        clearInterval( keepAliveId );
        // Borramos de la store el keepaliveInterval
        commit('setKeepaliveInterval', null);

    }

}




export default actions;